/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deft_Bold_Eel_GlowInputs */

const en_deft_bold_eel_glow = /** @type {(inputs: Deft_Bold_Eel_GlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notification sent`)
};

const de_deft_bold_eel_glow = /** @type {(inputs: Deft_Bold_Eel_GlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigung gesendet`)
};

/**
* | output |
* | --- |
* | "Notification sent" |
*
* @param {Deft_Bold_Eel_GlowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const deft_bold_eel_glow = /** @type {((inputs?: Deft_Bold_Eel_GlowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deft_Bold_Eel_GlowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deft_bold_eel_glow(inputs)
	return de_deft_bold_eel_glow(inputs)
});